const navigation = () => {
  const header = document.querySelector(".js-header");
  let lastScrollTop = 0;

  addEventListener(
    "scroll",
    () => {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop) {
        header.classList.add("hide");
      } else {
        header.classList.remove("hide");
      }
      lastScrollTop = st <= 0 ? 0 : st;
    },
    false
  );


  const firstLevel = [...document.querySelectorAll('.primary-menu > .menu-item-has-children')];
  const calculateNavHeight = () => {
    firstLevel.forEach(el => {
      if(!el.classList.contains('wpml-ls-item')) {
        const secondLevel = [...el.querySelectorAll('.primary-menu .sub-menu > .menu-item-has-children')]
        const allSubMenus = [...el.querySelectorAll('.sub-menu')]
        allSubMenus.forEach(sub => {
          sub.style.height = `auto`
        })
        let minHeight = el.querySelector('.sub-menu').getBoundingClientRect().height;
        secondLevel.forEach(secondEl => {
          const thirdLevel = [...secondEl.querySelectorAll('.primary-menu .sub-menu > .menu-item-has-children')]
            const height = secondEl.querySelector('.sub-menu').getBoundingClientRect().height
            if(height > minHeight) {
              minHeight = height;
            }
            thirdLevel.forEach(thirdEl => {
              const height = thirdEl.querySelector('.sub-menu').getBoundingClientRect().height
              if(height > minHeight) {
                minHeight = height;
              }
            })
        })
        allSubMenus.forEach(sub => {
          sub.style.height = `${minHeight}px`
        })
      }
    })
  }
  calculateNavHeight();

  const setHeightToAuto = () => {
    firstLevel.forEach(el => {
      if(!el.classList.contains('wpml-ls-item')) {
        const allSubMenus = [...el.querySelectorAll('.sub-menu')]
        allSubMenus.forEach(sub => {
          sub.style.height = `auto`
        })
      }
    })
  }

  let timeout;

  addEventListener('resize', ()=> {
    if(timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(()=> {
      if(window.innerWidth<=1300) {
        setHeightToAuto();
      } else {
        calculateNavHeight();
      }
    }, 500)
  })
};

export default navigation;
